import { Component } from '@angular/core';

@Component({
  selector: 'app-sales-blank',
  templateUrl: './sales-blank.component.html',
  styleUrls: ['./sales-blank.component.scss']
})
export class SalesBlankComponent {

}
